module.exports = __webpack_public_path__ + "img/login-ciudadelaejercito.3dce5572.svg";